<template>
    <div
        v-if="errors && errors[field]"
        class="invalid-feedback"
    >
        <span
            v-for="(error, index) in errors[field]"
            :key="index"
        >
            {{ error }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Object,
            default: () => ({})
        },
        field: {
            type: String,
            required: true
        }
    },
}
</script>
